var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"line-loader",class:[{ animate: _vm.show }, _vm.additionalClass]},[_c('div'),_c('div'),_c('div'),_c('div')]),(_vm.showScreen && _vm.show)?_c('div',{staticClass:"grey-screen",class:_vm.additionalClass}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }